// @flow


// TODO type
export const createResolverDecorator = (next: Function) => (diResolver: *): void => next(diResolver);

